import api from './api'

const listDataProvider = {
  getListData(params) {
    return api.post('Aggregator.Crm/api/Table/GetOne', params)
  },
}

export default listDataProvider
